export default {
  PER_PAGE: 30,
};



// WEBPACK FOOTER //
// ./src/Constants.js